export * from './post-factory.component';
export * from './post-factory.module';
